import { useLocation } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { useUiStore } from '@/stores'
import { taskKeys } from './useTasks'

export function usePageContext(): Record<string, unknown> {
  const { pathname } = useLocation()
  const queryClient = useQueryClient()
  const { selectedTaskId } = useUiStore()

  // Derive page name from route — no hardcoded map needed
  const currentPage = pathname === '/' ? 'dashboard' : pathname.slice(1).split('/')[0]
  const context: Record<string, unknown> = { current_page: currentPage }

  // Enrich with cached data for task-related pages
  if (currentPage === 'tasks') {
    // Read from TanStack Query cache — zero extra fetches
    const queries = queryClient.getQueriesData<{ items?: any[] }>({ queryKey: taskKeys.lists() })
    const items = queries?.[0]?.[1]?.items

    if (items?.length) {
      context.visible_tasks = items.slice(0, 15).map((t: any) => ({
        id: t.id,
        title: t.title,
        status: t.status,
        priority: t.priority,
        client_name: t.client_name,
      }))
    }

    if (selectedTaskId && items) {
      const selected = items.find((t: any) => t.id === selectedTaskId)
      if (selected) {
        context.selected_task = {
          id: selected.id,
          title: selected.title,
          status: selected.status,
          priority: selected.priority,
          client_name: selected.client_name,
        }
      }
    }
  }

  return context
}
